import React, { useEffect ,useState} from "react";
import NavbarHeader from "./NavbarHeader";
import Footer from "./Footer";
import Aos from "aos";
import 'aos/dist/aos.css';
import './StoreLocator.css';
import Card from 'react-bootstrap/Card';
import { Container,Row,Col, Button } from "react-bootstrap";
import { AnimationWrapper } from "react-hover-animation";
import { GeoAltFill, PersonBadgeFill, PersonFill, PhoneFill } from "react-bootstrap-icons";
import StoreData from "./StoreData";
import Gmaps from './About/Gmaps.jpg';



  export const StoreLocator = () =>{
    const loc="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d60912.23225808503!2d78.494708!3d17.411091!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9996bfffffff%3A0x25b713050c02d14a!2sGood%20Sight%20Opticals!5e0!3m2!1sen!2sau!4v1713160944941!5m2!1sen!2sau";
    const [gm, setgm] = useState(loc);
    
    const gs1=()=>{
        let newgm="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d60912.23225808503!2d78.494708!3d17.411091!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9996bfffffff%3A0x25b713050c02d14a!2sGood%20Sight%20Opticals!5e0!3m2!1sen!2sau!4v1713160944941!5m2!1sen!2sau";
        setgm(newgm);
        
    }
    const gs3 =()=>{
       let newgm="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.6429008735363!2d78.5030271746278!3d17.42891680160853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb998500000001%3A0xdc11f2c0c78c0d93!2sGood%20Sight%20Opticians!5e0!3m2!1sen!2sau!4v1713154600201!5m2!1sen!2sau";
       setgm(newgm);
    }
   const gs4=()=>{
    let newgm="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.615192909361!2d78.4245894746279!3d17.430245201570138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb912f18d1272d%3A0x8c8ee6a0e6811053!2sGood%20Sight%20Opticians!5e0!3m2!1sen!2sau!4v1713161320898!5m2!1sen!2sau";
    setgm(newgm);
   }
   const gs5=()=>{
    let newgm="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1781.3822946480784!2d78.50200737300108!3d17.490660848876693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b004c070a21%3A0x7ee0013c6a85a497!2sGood%20Sight%20Opticians!5e1!3m2!1sen!2sau!4v1733468515269!5m2!1sen!2sau";
    setgm(newgm);
   }
   const gs7=()=>{
    let newgm="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3803.268980166772!2d78.0843448!3d17.589957599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbfa2084a15975%3A0xc5200393f859fa96!2sGood%20Sight%20Opticians!5e0!3m2!1sen!2sau!4v1713161787037!5m2!1sen!2sau";
    setgm(newgm);
    

  
   }
   const gs7s1=()=>{
    let newgm="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1037.4800750345714!2d78.08047829911393!3d17.620839876750043!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf9bb95ec920b%3A0x9709264deb6c6019!2sGOOD%20SIGHT%20OPTICIANS!5e0!3m2!1sen!2sau!4v1713161981935!5m2!1sen!2sau";
    setgm(newgm);
    
   }


    useEffect(()=>{
        Aos.init({duration:2000});
    },[]);

    return(
        <div className="store" style={{overflowX:"hidden",overflowY:"hidden"}}>
            <NavbarHeader/>
            <div className="container">
            <br></br><br></br><br></br>   
           <center><AnimationWrapper config={{
        color: {
          initial: 'black',
          onHover: 'orange',
        },
      }}> 
      <br></br>
      <h1 data-aos="fade-up"><i>Our Stores</i></h1></AnimationWrapper></center> </div>
      <br></br>
           <Container>
           <Row>
                <Col data-aos="fade-up"  >
                <iframe data-aos="fade-left" src={gm} width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
               
               
                 
                <br></br>
                </Col>
            </Row>
            <br></br>
            <Row>
            {
                    StoreData.map((curelm)=>{
                      {if(curelm.ID==1){
                        var locs=gs1
                      }
                      if(curelm.ID==2){
                        var locs=gs3
                      }
                      if(curelm.ID==3){
                        var locs=gs4
                      }
                      if(curelm.ID==4){
                        var locs=gs5
                      }
                      if(curelm.ID==5){
                        var locs=gs7
                      }
                      if(curelm.ID==6){
                        var locs=gs7s1
                      }
                      }
                        return(
                          
                          <Col md={4} lg={4} xs={6} sm={4}>
                           <Card data-aos="fade-up" >
                            <Card.Header><b>{curelm.Header}</b></Card.Header>
                            <Card.Body>
                              <Card.Title></Card.Title>
                              <Card.Text>
                                
                              <center><Button  variant="danger" onClick={()=>locs()} >      <AnimationWrapper config={{color: {initial: 'white',onHover: 'black',},
                              }}><b><GeoAltFill/> </b></AnimationWrapper></Button></center>
                              <center><a href={curelm.Link}><img  src={Gmaps} alt="gmaps" height="20%" width="20%"/></a></center>
                                <br></br><PersonFill/>{curelm.Name}<br></br><PhoneFill/> {curelm.Phone}
                                </Card.Text>
                                
                            </Card.Body>
                            </Card>
                            <br></br>
                          </Col>
                          
                        )
                      })
            }   
            <br></br>     
            </Row>
                <br></br>
           
              
                
           
           </Container>
           <br></br>
         <Footer/>
        </div>
        
    )
}

export default StoreLocator;